<template>
  <div>
    <creation-modal
      class="base-modal"
      :title="isEditMode ? 'Edition client' : 'Nouveau Client'"
      id="editClient"
      ref="EditModalComponent"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <loading class="small" v-if="this.loading"/>
      <b-form v-else @submit.prevent="handleSubmit">
        <div class="row form-stylizer">
          <div class="col-md-6">
            <div id="type-group">
              <b-form-select
                id="type-input"
                v-model="form.typeClient"
                :options="typeOptions"
              >
              </b-form-select>
            </div>
            <div
              id="nom-client-group"
            >
              <b-form-input
                v-model="form.nom"
                id="nom-client-input"
                type="text"
                placeholder="Nom *"
                required
              >
              </b-form-input>
            </div>
            <div
              id="adresse-client-group"
            >
              <b-form-input
                v-model="form.adresse"
                id="adresse-client-input"
                type="text"
                placeholder="Adresse"
              >
              </b-form-input>
            </div>
            <div
              id="complementAdresse-client-group"
            >
              <b-form-input
                v-model="form.complementAdresse"
                id="complementAdresse-client-input"
                type="text"
                placeholder="Complément d'adresse"
              >
              </b-form-input>
            </div>
            <div class="row">
              <div
                id="code-postal-group"
                class="col-md-4"
              >
                <b-form-input
                  v-model="form.codePostal"
                  id="code-postal-input"
                  type="number"
                  placeholder="CP *"
                >
                </b-form-input>
              </div>
              <div
                id="ville-group"
                class="col-md-8"
              >
                <b-form-input
                  v-model="form.ville"
                  id="ville-input"
                  type="text"
                  placeholder="Ville"
                >
                </b-form-input>
              </div>
            </div>
            <div id="pays-group">
              <b-form-input v-model="form.pays" id="pays-input" type="text" placeholder="Pays">
              </b-form-input>
            </div>
          </div>
          <div class="col-md-6">
            <div
              id="nom-contact-group"
            >
              <b-form-input
                v-model="form.contactNom"
                id="nom-contact-input"
                type="text"
                placeholder="Nom du contact"
              >
              </b-form-input>
            </div>
            <div
              id="prenom-contact-group"
            >
              <b-form-input
                v-model="form.contactPrenom"
                id="prenom-contact-input"
                type="text"
                placeholder="Prenom du contact"
              >
              </b-form-input>
            </div>
            <div
              id="tel1-contact-group"
            >
              <b-form-input
                v-model="form.contactTel1"
                id="tel1-contact-input"
                type="text"
                placeholder="Téléphone"
              >
              </b-form-input>
            </div>
            <div
              id="tel2-contact-group"
            >
              <b-form-input
                v-model="form.contactTel2"
                id="tel2-contact-input"
                type="text"
                placeholder="Mobile"
              >
              </b-form-input>
            </div>
            <div
              id="email1-contact-group"
            >
              <b-form-input
                v-model="form.email1"
                id="email1-contact-input"
                type="email"
                placeholder="Email 1 du contact"
              >
              </b-form-input>
            </div>
            <div
              id="email2-contact-group"
            >
              <b-form-input
                v-model="form.email2"
                id="email2-contact-input"
                type="email"
                placeholder="Email 2 du contact"
              >
              </b-form-input>
            </div>
          </div>
        </div>
        <div>
          <div class="button-wrap validation-button d-flex justify-content-end">
            <p class="obligatoire">* Champs obligatoire</p>
            <b-button
              variant="outline-primary"
              @click="closeModal()"
              >Annuler</b-button
            >
            <template v-if="!this.pending()">
              <b-button
                v-if="!isEditMode"
                type="submit"
                variant="outline-primary"
                class="lg-btn"
                >Valider</b-button
              >
              <b-button
                v-if="isEditMode"
                type="submit"
                variant="outline-primary"
                class="lg-btn"
                >Modifier</b-button
              >
            </template>
            <b-button v-else class="txt-btn" variant="primary">
              <b-spinner small type="grow"></b-spinner> En cours...
            </b-button>
          </div>
        </div>
      </b-form>
    </creation-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import creationModal from '../utils/creationModal'
import loading from '../loading'
export default {
  components: {
    creationModal,
    loading
  },
  data () {
    return {
      isEditMode: true,
      loading: true,
      clientId: null,
      typeOptions: [
        { value: 1, text: 'Privé' },
        { value: 2, text: 'Collectivité' },
        { value: 3, text: 'SEM' },
        { value: 4, text: 'Etat' },
        { value: 5, text: 'EPS' },
        { value: 6, text: 'EPMS' },
        { value: 7, text: 'Particulier' },
        { value: 8, text: 'Autre' }
      ],
      form: {
        nom: '',
        contactNom: '',
        contactPrenom: '',
        contactTel1: '',
        contactTel2: '',
        email1: '',
        email2: '',
        adresse: '',
        complementAdresse: '',
        codePostal: 0,
        ville: '',
        pays: '',
        societe: this.userSocieteId(),
        typeClient: 1
      }
    }
  },
  methods: {
    ...mapActions(['setMessage', 'getAdminClient', 'setLoading', 'updateAdminClient', 'setPending', 'addAdminClient']),
    ...mapGetters(['userSocieteId', 'pending']),
    async openModal (id = null) {
      this.isEditMode = id != null
      this.loading = true
      this.$refs['EditModalComponent'].openModal()
      if (this.isEditMode) {
        const resp = await this.getAdminClient(id)
        this.clientId = resp.id
        let type = this.form.typeClient
        this.form = resp
        delete this.form.societeId
        delete this.form.societeNom
        this.form.societe = this.userSocieteId()
        this.form.typeClient = type
      } else {
        this.form = {
          nom: '',
          contactNom: '',
          contactPrenom: '',
          contactTel1: '',
          contactTel2: '',
          email1: '',
          email2: '',
          adresse: '',
          complementAdresse: '',
          codePostal: '',
          ville: '',
          pays: '',
          societe: this.userSocieteId(),
          typeClient: 1
        }
      }
      this.loading = false
    },
    closeModal () {
      this.$refs['EditModalComponent'].closeModal()
    },
    handleSubmit () {
      this.setPending(true)
      if (this.isEditMode) {
        this.updateAdminClient({ id: this.clientId, data: this.form }).then((resp) => {
          this.setMessage('Client modifié')
          this.closeModal()
          this.$emit('updateClient')
        }, (err) => {
          // this.$toaster.error(err)
          this.setMessage(err)
        }).finally(_ => {
          this.setPending(false)
        })
        return
      }
      this.addAdminClient(this.form).then((resp) => {
        // this.$toaster.success('Client ajouté')
        this.setMessage('Client ajouté')
        this.closeModal()
        this.$emit('updateClient')
      }, (err) => {
        // this.$toaster.error(err)
        this.setMessage(err)
      }).finally(_ => {
        this.setPending(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
input::placeholder {
  color: #2b3085;
  opacity: .6;
  font-size: 12px;
}

.small{
  position: relative;
}
.left-padding {
  padding-left: 45px;
}
#editClient{
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientEditModal.vue